"use client";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { setLastWorkspaceIdCookie } from "@/lib/cookie/cookie-client";
import { useRouter } from "@/lib/navigation";

export function WorkspaceDropdownItem({
  workspaceId,
  children,
}: {
  workspaceId: string;
  children: React.ReactNode;
}) {
  const router = useRouter();
  const handleHover = () => {
    router.prefetch(`/${encodeURIComponent(workspaceId)}`);
  };
  const handleClick = () => {
    setLastWorkspaceIdCookie(workspaceId);
    router.push(`/${encodeURIComponent(workspaceId)}`);
  };

  return (
    <DropdownMenuItem onClick={handleClick} onMouseEnter={handleHover}>
      {children}
    </DropdownMenuItem>
  );
}
